class ComplementaryProducts extends HTMLElement {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    if (theme.settings.afterAddToCart !== 'no-js') {
      this.addEventListener('submit', this.handleSubmit);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.handleSubmit);
  }

  async handleSubmit(evt) {
    const form = evt.target.closest('.js-complementary-products-form');
    if (!form || !this.contains(form)) return;

    evt.preventDefault();

    if (!form.reportValidity()) return;

    const submitBtn = form.querySelector('[name="add"]');
    const errorEl = form.querySelector('.js-complementary-form-error');
    const statusEl = this.querySelector('.js-complementary-status');

    this.setError(errorEl);
    if (statusEl) statusEl.textContent = '';

    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('is-loading');
    }

    const formData = new FormData(form);
    const sectionsToUpdate = ['page-header', 'cart-drawer'].map((sel) => document.querySelector(sel)).filter((el) => el);
    const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);

    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sectionIds.join(','));

    try {
      const response = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', ')).join(', ');
        }
        throw new Error(error || this.dataset.errorMessage);
      }

      await this.afterAddToCart(data, sectionsToUpdate, submitBtn);

      const modal = form.closest('modal-dialog');
      if (modal && typeof modal.close === 'function') modal.close();

      if (statusEl) statusEl.textContent = this.dataset.addedMessage;
    } catch (error) {
      this.setError(errorEl, error.message || this.dataset.errorMessage);
      this.dispatchEvent(new CustomEvent('on:cart:error', {
        bubbles: true,
        detail: { error: error.message }
      }));
      this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    } finally {
      if (submitBtn) {
        submitBtn.classList.remove('is-loading');
        submitBtn.removeAttribute('aria-disabled');
      }
    }
  }

  async afterAddToCart(data, sectionsToUpdate, submitBtn) {
    if (document.querySelector('.template-cart')) {
      const cartForm = document.querySelector('cart-form');
      if (cartForm && cartForm.enableAjaxUpdate) {
        cartForm.refresh();
      }
    } else if (theme.settings.afterAddToCart === 'page') {
      window.location.href = theme.routes.cart;
      return;
    } else {
      if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
        sectionsToUpdate.forEach((el) => {
          el.updateFromCartChange(data.sections[el.dataset.sectionId]);
        });
      } else {
        this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      }

      if (theme.settings.afterAddToCart === 'notification') {
        const notificationTemplate = document.getElementById('AddedNotification');
        if (notificationTemplate) {
          const notification = notificationTemplate.content.firstElementChild.cloneNode(true);
          notification.dataset.productTitle = data.product_title;
          let notificationContainer = document.querySelector('.pageheader--sticky');
          if (!notificationContainer) notificationContainer = document.querySelector('body');
          notificationContainer.appendChild(notification);
        }
      } else if (theme.settings.afterAddToCart === 'drawer') {
        const cartDrawer = document.querySelector('.js-cart-drawer');
        if (cartDrawer) cartDrawer.open(submitBtn);
      }
    }

    this.dispatchEvent(new CustomEvent('on:cart:add', {
      bubbles: true,
      detail: { variantId: data.variant_id }
    }));
  }

  setError(errorEl, error = false) {
    if (!errorEl) return;

    errorEl.hidden = !error;
    errorEl.textContent = error || '';
  }
}

if (!customElements.get('complementary-products')) {
  customElements.define('complementary-products', ComplementaryProducts);
}
